import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SpeechToInsights from '../pages/SpeechToInsights/SpeechToInsights';
import NotAuthorized from '../pages/NotAuthorized/NotAuthorized';
import ProtectedMainLayout from './ProtectedMainLayout';

export const AppRouter: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<ProtectedMainLayout />}>
                    <Route index element={<SpeechToInsights />} />
                </Route>
                <Route path="/speech-to-insights" element={<ProtectedMainLayout />}>
                    <Route index element={<SpeechToInsights />} />
                </Route>
                <Route path="/not-authorized" element={<ProtectedMainLayout />}>
                    <Route index element={<NotAuthorized />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};
